import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
import axios from 'axios';
import API from '../api/api';
export var strict = false;
export var state = function state() {
  return {
    authUser: null,
    countNoti: 0,
    listNotification: []
  };
};

export var mutations = {
  SET_USER: function SET_USER(state, user) {
    state.authUser = user;
  },
  SET_LIST: function SET_LIST(state, list) {
    state.listNotification = list;

    state.countNoti = list.filter(function (o) {
      return o.isRead === 'No';
    }).length;
  }
};

export var actions = {
  // nuxtServerInit is called by Nuxt.js before server-rendering every page
  nuxtServerInit: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit = _ref.commit;
      var req = _ref2.req;
      var result, notification;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(req.session && req.session.authUser)) {
                _context.next = 8;
                break;
              }

              commit('SET_USER', req.session.authUser);
              _context.next = 4;
              return API.setToken(req.session.authUser.tokenID);

            case 4:
              _context.next = 6;
              return API.loadNotification(req.session.authUser.userID);

            case 6:
              result = _context.sent;


              if (result.data.code === 200 && result.data.flag === true) {
                notification = result.data.datas;


                commit('SET_LIST', notification);
              }

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function nuxtServerInit(_x, _x2) {
      return _ref3.apply(this, arguments);
    }

    return nuxtServerInit;
  }(),
  login: function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4, userObj) {
      var commit = _ref4.commit;

      var _ref6, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              axios.defaults.baseURL = '';
              _context2.next = 4;
              return axios.post('/api/login', userObj);

            case 4:
              _ref6 = _context2.sent;
              data = _ref6.data;

              commit('SET_USER', data);
              _context2.next = 14;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](0);

              if (!(_context2.t0.response && _context2.t0.response.status === 401)) {
                _context2.next = 13;
                break;
              }

              throw new Error('Bad credentials');

            case 13:
              throw _context2.t0;

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 9]]);
    }));

    function login(_x3, _x4) {
      return _ref5.apply(this, arguments);
    }

    return login;
  }(),
  loadComment: function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7, _ref8) {
      var commit = _ref7.commit;
      var req = _ref8.req;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function loadComment(_x5, _x6) {
      return _ref9.apply(this, arguments);
    }

    return loadComment;
  }(),
  logout: function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref10) {
      var commit = _ref10.commit;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return axios.post('/api/logout');

            case 2:
              commit('SET_USER', null);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function logout(_x7) {
      return _ref11.apply(this, arguments);
    }

    return logout;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = ./store/index.js
// module chunks = 82